import React from 'react';
import PropTypes from 'prop-types';

import {CircularProgress, Backdrop} from '@ui';

const RedirectView = ({isRedirectLoaderVisible}) => (
    <Backdrop open={isRedirectLoaderVisible}>
        <CircularProgress size='large' />
        Loading
    </Backdrop>
);

RedirectView.propTypes = {
    isRedirectLoaderVisible: PropTypes.bool,
};

RedirectView.defaultProps = {
    isRedirectLoaderVisible: false,
};

export default RedirectView;
